import React, { useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as actionsLinePicking from '../../../../../actions/linePickingAction';
import * as deliveryAction from '../../../../../actions/deliveryAction';
import Breadcrumbs from '../../../../../components/UI/Breadcrumbs';
import ButtonUI from '../../../../../components/UI/ButtonUI';
import { Collapsible, List, SelectItem, SelectShed } from '../../../../../components/UI/ComponentsUI';
import InputUI from '../../../../../components/UI/InputUI';
import ScannerCode from '../../../../../components/UI/ScannerCode';
import DeliveryService from '../../../../../services/DeliveryService';
import JustificationService from '../../../../../services/JustificationService';
import { ENUMS, PERMISSIONS, VISIONS } from '../../../../../utils/constants';
import { onValueChange, validateInputsRequired } from '../../../../../utils/handleChangeHooks';
import { enumText, getPathApp, isNullOrEmpty, showMessageToastCustom, translate, updateTextFields } from '../../../../../utils/util';
import ConfirmeModalCallDelivery from './ConfirmeModalCallDelivery';
import { checkPermission, getVision } from '../../../../../services/auth';
import LinePickingService from '../../../../../services/LinePickingService';

const ManualCallDelivery = (props) => {
    let confirmeModalCallDelivery;
    const [callFilter, setCallFilter] = useState({
        pdu: props.filterManualCall.pdu || '',
        partNumber: props.filterManualCall.partNumber || '',
        quantity: 1,
        area: props.user.shed || ''
    });
    const [ordersDelivery, setOrdersDelivery] = useState([]);
    const [ordersLine, setOrdersLine] = useState([]);
    const [visible, setVisible] = useState(false);
    const [justification, setJustification] = useState([]);
    const [pduList, setPduList] = useState([]);
    const getStatus = (value) => translate(enumText(ENUMS.eOrderStatus, value), 'expedition');

    useEffect(() => {
        if (!props.justifications?.items || props.justifications?.items?.length === 0) {
            props.getJustifications(props.user.vision, {});
        }
        if (!isNullOrEmpty(callFilter.pdu) && !isNullOrEmpty(callFilter.partNumber)) {
            onClickSearch();
        }
        // eslint-disable-next-line
    }, []);


    useEffect(() => {
        if (!isNullOrEmpty(callFilter.area)) {
            var shed = props.sheds.find((i) => i.code === callFilter.area);
            if (shed) {
                let filter = {
                    areaId: shed.areaId,
                };
                props.getAreaPdu(filter, (result) => {
                    if (result) {
                        setPduList([...result]);
                    }
                });
            } else {
                console.log(`SHED ${callFilter.area} não encontrada`)
            }
        }
        // eslint-disable-next-line
    }, [callFilter.area]);

    useEffect(() => {
        if (props.justifications?.items) {
            const justificationFilter = props.justifications.items.filter((f) => f.justificationTypeId === 4);
            setJustification(justificationFilter || [])
        }
        // eslint-disable-next-line
    }, [props.justifications?.items]);

    const onChange = (event) => {
        onValueChange(event, callFilter, setCallFilter);
    };

    const onChangePdu = (event) => {
        const formatted = event.replace(/\s/gi, '');
        if (formatted !== event) {
            event = formatted;
        }
        callFilter.pdu = event;
        setCallFilter({ ...callFilter });
    }

    const onClickSearch = () => {
        if (validateInputsRequired("formCallDelivery")) {
            props.getDeliveryCall(callFilter, (response) => {
                setVisible(true);
                if (response) {
                    setOrdersDelivery(response.filter((f) => f.type === ENUMS.eOrderType.Delivery.value));
                    setOrdersLine(response.filter((f) => f.type === ENUMS.eOrderType.LinePicking.value))
                }
            })
        }
    };

    const addQuantity = () => {
        callFilter.quantity = callFilter.quantity + 1;
        setCallFilter({ ...callFilter });
    };

    const subtractQuantity = () => {
        if (callFilter.quantity - 1 > 0) {
            callFilter.quantity = callFilter.quantity - 1;
            setCallFilter({ ...callFilter });
        }
    };

    const onSendCall = (justificationId) => {
        callFilter.justificationId = justificationId;
        props.sendManualCall(callFilter, (response) => {
            if (response) {
                showMessageToastCustom(translate('general.info'), translate("delivery:message.manual-call"), 8000, 'mdi mdi-checkbox-marked-circle-outline green-text');
                setVisible(false);
                updateTextFields();
            }
        });
    }

    const onClickSend = () => {
        if (validateInputsRequired("formCallDelivery")) {
            confirmeModalCallDelivery.show();
        }
    };

    const scannerPdu = (value) => {
        if (!isNullOrEmpty(value)) {
            setCallFilter({ ...callFilter, pdu: value });
        }
    };

    const scannerPartNumber = (value) => {
        if (!isNullOrEmpty(value)) {
            setCallFilter({ ...callFilter, partNumber: value });
        }
    };

    const onConfirmModalLine = (order) => {
        if (order.status === ENUMS.eOrderStatus.Waiting.value
            || order.status === ENUMS.eOrderStatus.WaitingRouteComposition.value
            || (order.status === ENUMS.eOrderStatus.InProgress.value)) {
            props.startOrder(order.orderId, () => {
                props.setSelectedOrder(order);
                const mission = order.items?.find(o => o.status === ENUMS.eOrderItemStatus.Waiting.value || o.status === ENUMS.eOrderItemStatus.InProgress.value);
                if (mission) {
                    props.setSelectedMission(mission);
                    props.startOrderItem(order.orderId, mission.orderItemId, null);
                    props.history.push({
                        pathname: `${getPathApp(window)}/linePicking/smallParts/order/missions/${mission.orderItemId}`
                    });
                    props.setFilterManualCall(callFilter);
                }
            });
        }
        else {
            showMessageToastCustom(translate('general:warning'), `O pedido está ${getStatus(order.status)} `, 8000, 'mdi mdi-alert-circle-outline orange-text');
        }
    };

    const onConfirmModalDelivery = (order) => {
        props.setOrder(order);
        props.history.push({
            pathname: `../delivery/startDelivery/order/missions/${order.items[0].orderItemId}`
        });
    };

    const renderItem = (order) => {
        return (
            order.items ? order.items.map((orderItem) => {
                return <div
                    className="row"
                    key={`${order.orderId}`}
                    style={{ backgroundColor: 'white', color: 'black', padding: '12px', display: 'block', marginBottom: '0px' }}
                >
                    <div className="col s10" style={{ padding: '0px' }}>
                        <div className="col s12" style={{ padding: '0px', fontWeight: 'bold' }}>{`${translate('expedition:picking.orderCode')}: ${order.orderCode}`}</div>
                        <div className="col s12" style={{ padding: '0px' }}>{`CIM: ${orderItem?.cim}`}</div>
                        <div className="col s7" style={{ padding: '0px' }}>{`${translate('line-picking:linepicking.location')}: ${orderItem?.location}`}</div>
                    </div>
                    {(order.status === ENUMS.eOrderStatus.Waiting.value
                        || order.status === ENUMS.eOrderStatus.WaitingRouteComposition.value
                        || order.status === ENUMS.eOrderStatus.InProgress.value) &&
                        <div className="col s2" style={{ padding: '0px' }}>
                            <span
                                id="refresh"
                                className="title sixth-text-color right"
                                style={{ position: 'absolute', marginTop: '30px', right: '45px', zIndex: '999' }}

                                onClick={() => {
                                    if (order.type === ENUMS.eOrderType.Delivery.value) {
                                        onConfirmModalDelivery(order);
                                    } else {
                                        onConfirmModalLine(order);
                                    }
                                }}
                            >
                                <i className="mdi mdi-camera-timer" style={{ cursor: 'pointer' }} />
                            </span>
                        </div>
                    }
                </div>
            }) : <></>
        )
    }

    return (
        <>
            <Breadcrumbs id="idBreadcrumbs" title={{ icon: "mdi mdi-gesture-tap-hold", label: translate('delivery:general.manualOrder') }} />
            <div className="container-fluid" style={{ marginTop: '25px', }}>
                <div className="container">
                    <div className="card">
                        <div id="formCallDelivery" className="card-content" style={{ padding: '8px', paddingBlockEnd: '8px' }}>
                            <fieldset className='fieldset'>
                                <div className="input-field col s12">
                                    <SelectShed
                                        id="area"
                                        value={callFilter.area}
                                        onChange={onChange}
                                        required={false}
                                    />
                                </div>
                                <div className="input-field no-padding col s12">
                                    <InputUI
                                        required
                                        id='partNumber'
                                        name='partNumber'
                                        type="text"
                                        label={translate('delivery:fields.partNumber')}
                                        onChange={onChange}
                                        numericonly="true"
                                        padleftchar="0"
                                        maxLength={11}
                                        defaultValue={callFilter?.partNumber || ''}
                                    />
                                    <ScannerCode className="mdi mdi-barcode-scan posfix disable" onScanner={scannerPartNumber} markerCodeBar={true} />
                                </div>
                                <div className="input-field no-padding col s12">
                                    <SelectItem
                                        required
                                        id="pdu"
                                        name="pdu"
                                        textDefault="true"
                                        label={translate('delivery:fields.pdu')}
                                        onChangeData={onChangePdu}
                                        onChange={onChangePdu}
                                        defaultValue={props.filterManualCall?.pdu || ''}
                                        minLength={0}
                                        data={
                                            pduList.map((i) => {
                                                return { id: i.locationTarget, text: i.locationTarget };
                                            })} />

                                    <ScannerCode className="mdi mdi-barcode-scan posfix disable" onScanner={scannerPdu} markerCodeBar={true} />
                                </div>
                            </fieldset>
                        </div>
                    </div>
                    <div className="row">
                        <ButtonUI onClick={() => onClickSearch()} full="true" text={translate('delivery:general.search')} />
                    </div>
                </div>
                {
                    visible && (
                        <>
                            <Collapsible
                                id="linePicking"
                                close="true"
                                header={`${translate('expedition:picking.order-status.waiting')} ${translate('delivery:general.picking')} ${ordersLine.length}`}
                                body={
                                    <div>
                                        {ordersLine.length > 0 &&
                                            <List
                                                data={
                                                    ordersLine.map((item) => {
                                                        return renderItem(item);
                                                    })
                                                }
                                            />
                                        }
                                    </div>
                                }
                            />
                            {
                                checkPermission(PERMISSIONS.Delivery.Access) && getVision() !== VISIONS.Fiasa && getVision() !== VISIONS.Faasa && getVision() !== VISIONS.FaasaCKD
                                &&
                                < Collapsible
                                    id="delivery"
                                    close="true"
                                    header={`${translate('expedition:picking.order-status.waiting')} ${translate('delivery:title')} ${ordersDelivery.length}`}
                                    body={
                                        <div>
                                            {ordersDelivery.length > 0 &&
                                                <List
                                                    data={
                                                        ordersDelivery.map((item) => {
                                                            return renderItem(item);
                                                        })
                                                    }
                                                />
                                            }
                                        </div>
                                    }
                                />
                            }

                            <div className="row">
                                <div className="padding col s4" />
                                <div className="padding col s1" >
                                    <ButtonUI onClick={() => subtractQuantity()} className="btn-floating btn-small waves-effect" full="true" text="-" />
                                </div>
                                <div className="padding col s2" style={{ textAlign: "center" }}>
                                    <InputUI
                                        id="quantity"
                                        name="quantity"
                                        type="number"
                                        step='1'
                                        min="0"
                                        onChange={(evt) => { if (evt.target.value > 0) { onChange(evt); } }}
                                        value={callFilter.quantity}>
                                    </InputUI>
                                </div>
                                <div className="padding col s1">
                                    <ButtonUI onClick={() => addQuantity()} className="btn-floating btn-small waves-effect" full="true" text="+" />
                                </div>
                                <div className="padding col s4" ></div>
                            </div>
                            <div className="row">
                                <ButtonUI onClick={() => onClickSend()} full="true" text={translate('delivery:general.send')} />
                            </div>
                        </>
                    )
                }
            </div>
            {
                visible ? (
                    <ConfirmeModalCallDelivery
                        ref={((el) => confirmeModalCallDelivery = el)}
                        data={{ title: translate('delivery:general.manualOrder') }}
                        id="ConfirmeModalCallDelivery"
                        onConfirm={onSendCall}
                        btnCancel={translate('general:cancel')}
                        btnConfirm={translate('general:confirm')}
                        justifications={justification}
                    />
                ) : null
            }
        </>
    );
}

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        justifications: state.justificationReducer.justifications,
        sheds: state.configReducer.sheds,
        filterManualCall: state.deliveryReducer.filterManualCall
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getDeliveryCall: (filter, callback) => {
            dispatch(DeliveryService.getDeliveryCall(filter, callback));
        },
        sendManualCall: (filter, callback) => {
            dispatch(DeliveryService.sendManualCall(filter, callback));
        },
        getJustifications: (vision, filter, pagination) => {
            dispatch(JustificationService.getJustifications(vision, filter, pagination));
        },
        startOrder: (orderId, callback) => {
            dispatch(LinePickingService.startOrder(orderId, callback));
        },
        startOrderItem: (orderId, orderItemId, callback) => {
            dispatch(LinePickingService.startOrderItem(orderId, orderItemId, callback));
        },
        setSelectedOrder: (order) => {
            dispatch(actionsLinePicking.selectOrder(order));
        },
        setSelectedMission: (mission) => {
            dispatch(actionsLinePicking.selectMission(mission));
        },
        setOrder: (order) => {
            dispatch(deliveryAction.setOrder(order));
        },
        setFilterManualCall: (filter) => {
            dispatch(deliveryAction.setFilterManualCall(filter));
        },
        getAreaPdu: (data, callback) => {
            dispatch(DeliveryService.GetAreaPdu(data, callback));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ManualCallDelivery)));